import { useState, useEffect } from "react"
import { products } from "../content/Cart"

export interface CartItem {
    id: string
    product_id: string
    title: string
    image: string
    price: number
    qty: number
}

export const useCart = () => {
    const [cartItems, setCartItems] = useState<CartItem[]>(() => {
        if (typeof window !== "undefined") {
            const saved = localStorage.getItem("cartItems")
            return saved ? JSON.parse(saved) : []
        }
        return []
    })

    useEffect(() => {
        if (typeof window !== "undefined") {
            localStorage.setItem("cartItems", JSON.stringify(cartItems))
        }
    }, [cartItems])

    const addToCart = (item: { product_id: string; qty?: number }) => {
        // ✅ product_id se product dhundo
        const product = products.find((p) => p.product_id === item.product_id)
        if (!product) return

        const id = product.product_id
        const price = Number(product.price)

        setCartItems((prev) => {
            const existing = prev.find((i) => i.id === id)
            if (existing) {
                return prev.map((i) =>
                    i.id === id ? { ...i, qty: i.qty + (item.qty ?? 1) } : i
                )
            }
            return [...prev, {
                id,
                product_id: product.product_id,
                title: product.title,         
                image: product.image,     
                price,                         
                qty: item.qty ?? 1
            }]
        })
    }

    const changeQty = (id: string, delta: number) => {
        setCartItems((prev) =>
            prev.map((i) => i.id === id ? { ...i, qty: Math.max(1, i.qty + delta) } : i)
        )
    }

    const removeItem = (id: string) => {
        setCartItems((prev) => prev.filter((i) => i.id !== id))
    }
    const clearCart = () => {
    setCartItems([])
    localStorage.removeItem("cartItems")
}

    const totalItems = cartItems.reduce((s, i) => s + i.qty, 0)
    const subtotal = cartItems.reduce((s, i) => s + i.price * i.qty, 0)

    return { cartItems, addToCart, changeQty, removeItem, totalItems, subtotal, clearCart }
}